import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import Dropdown from '../../../../components/Dropdown';
import PhoneNumber from '../../../../components/PhoneNumber';
import { CAN_GENDER, CAN_TYPES } from '../../../../Const';
import { handleDatePicker } from '../../../../Functions/apis';

const PreProfile = ({
    input,
    handleChange,
    handleSubmit,
    simpleValidator,
    dateObj,
    checkYear,
    role
}) => {
    var maxDate = handleDatePicker(dateObj);
    const history = useHistory();

    return (
        <div className="page-content bg-white">
            <div className="content-block">
                <div className="section-full bg-white browse-job p-b20">
                    <div className="ml-5 mr-5">
                        <div className="row">
                            <div className="col-12 m-b30">
                                <div className="job-bx job-profile">
                                    <div className="job-bx-title clearfix">
                                        <h5 className="font-weight-700 pull-left text-uppercase">Basic Information</h5>
                                        <Link to="#" onClick={() => history.goBack()} className="site-button right-arrow button-sm float-right">Back</Link>
                                    </div>
                                    <form onSubmit={(e) => handleSubmit(e)}>
                                        <div className="row m-b30">
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>First Name <span className="text-danger font-weight-bold">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter your first name"
                                                        name="first_name"
                                                        value={input?.first_name || ''}
                                                        onChange={handleChange}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("first name", input?.first_name, "required")}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Last Name <span className="text-danger font-weight-bold">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter your last name"
                                                        name='last_name'
                                                        value={input?.last_name || ''}
                                                        onChange={handleChange}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("last name", input?.last_name, "required")}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Type <span className="text-danger font-weight-bold">*</span></label>
                                                    <Dropdown
                                                        name="can_type"
                                                        options={CAN_TYPES}
                                                        onChange={handleChange}
                                                        value={input?.can_type}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("Type", input?.can_type, "required")}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Professional title <span className="text-danger font-weight-bold">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="eg. Web Designer"
                                                        name='professional_title'
                                                        value={input?.professional_title || ''}
                                                        onChange={handleChange}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("professional title", input?.professional_title, "required")}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Date Of Birth <span className="text-danger font-weight-bold">*</span></label>
                                                    <input
                                                        type="date"
                                                        name="date_of_birth"
                                                        value={input?.date_of_birth}
                                                        onChange={handleChange}
                                                        onKeyPress={(e) => e.preventDefault()}
                                                        className="form-control"
                                                        max={maxDate}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("date_of_birth", input?.date_of_birth, "required")}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Age <span className="text-danger font-weight-bold">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Please select DOB"
                                                        name='age'
                                                        value={checkYear || ""}
                                                        disabled={true}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("age", input?.age, "required|gte:18")}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Gender <span className="text-danger font-weight-bold">*</span></label>
                                                    <Dropdown
                                                        name="gender"
                                                        options={CAN_GENDER}
                                                        onChange={handleChange}
                                                        value={input?.gender}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("gender", input?.gender, "required")}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Current Salary </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="eg. 2000$"
                                                        name='current_salary'
                                                        value={input?.current_salary || ''}
                                                        onChange={handleChange}
                                                        onKeyPress={e => e.target.value.length >= 8 && e.preventDefault()}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Expected Salary <span className="text-danger font-weight-bold">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="eg. 2500$"
                                                        name='expected_salary'
                                                        value={input?.expected_salary || ''}
                                                        onChange={handleChange}
                                                        onKeyPress={e => e.target.value.length >= 8 && e.preventDefault()}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("expected_salary", input?.expected_salary, "required")}
                                                    </span>
                                                </div>
                                            </div>
                                            {/* <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Email Address <span className="text-danger font-weight-bold">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="info@example.com"
                                                        name='email'
                                                        disabled={true}
                                                        value={user?.email || ''}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div> */}
                                            <div className="col-lg-12 col-md-12">
                                                <div className="form-group">
                                                    <label>Description <span className="text-danger font-weight-bold">*</span></label>
                                                    <textarea
                                                        className="form-control"
                                                        name='description'
                                                        value={input?.description || ''}
                                                        onChange={handleChange}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("description", input?.description, "required")}
                                                    </span>
                                                </div>
                                            </div>
                                            {
                                                role === 1 &&
                                                <div className="col-lg-12 col-md-12">
                                                    <div className="form-group">
                                                        <label>JOC Description <span className="text-danger font-weight-bold">*</span></label>
                                                        <textarea
                                                            className="form-control"
                                                            name='joc_description'
                                                            value={input?.joc_description || ''}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div className="job-bx-title clearfix">
                                            <h5 className="font-weight-700 pull-left text-uppercase">Contact Information</h5>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Phone <span className="text-danger font-weight-bold">*</span></label>
                                                    {/* <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="With Country Code. Eg. +1 123 456 7890"
                                                        name='mobile'
                                                        value={input?.mobile || ''}
                                                        onChange={handleChange}
                                                    /> */}
                                                    <PhoneNumber
                                                        name='mobile'
                                                        value={input?.mobile || ''}
                                                        onChange={handleChange}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("mobile", input?.mobile, "required|min:6")}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Full Address <span className="text-danger font-weight-bold">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="New york City"
                                                        name='address'
                                                        value={input?.address || ''}
                                                        onChange={handleChange}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("address", input?.address, "required")}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Country <span className="text-danger font-weight-bold">*</span></label>
                                                    <Dropdown
                                                        name="country"
                                                        url="country/"
                                                        onChange={handleChange}
                                                        value={input?.country || ''}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("country", input?.country, "required")}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Region <span className="text-danger font-weight-bold">*</span></label>
                                                    <Dropdown
                                                        name="state"
                                                        url="state/"
                                                        filters={input?.country?.id && `country__in=${input?.country?.id}`}
                                                        onChange={handleChange}
                                                        value={input?.state || ''}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("state", input?.state, "required")}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Location <span className="text-danger font-weight-bold">*</span></label>
                                                    <Dropdown
                                                        name="city"
                                                        url="city/"
                                                        filters={input?.state?.id && `state__in=${input?.state?.id}`}
                                                        onChange={handleChange}
                                                        value={input?.city || ''}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("city", input?.city, "required")}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>Postcode/ZipCode <span className="text-danger font-weight-bold">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="eg. 123456"
                                                        name='pincode'
                                                        value={input?.pincode || ''}
                                                        onChange={handleChange}
                                                        onKeyPress={e => e.target.value.length >= 7 && e.preventDefault()}
                                                    />
                                                    <span className="text-danger">
                                                        {simpleValidator.current.message("pincode", input?.pincode, "required|numeric")}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <button className="site-button m-b30">{Object.values(input).length > 0 ? "Update" : "Save"}</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreProfile;